import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { Numerology, Header, Footer } from './components';
import { About, ContactUs, Faq } from './pages';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ReportPage from './pages/ReportPage';

function App() {
  return (
    <>
    <BrowserRouter basename="/mobilenumerology" >
        <div className="main-app-container">
          <Header />
          <Routes>
            <Route path="/" element={<Numerology />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/Faq" element={<Faq />} />
            <Route path="/report" element={<ReportPage />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
